let oauthWindowRef;
let handlePost;

export const oauthInit = (type, dataPassed) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/start?type=${type}`;

  if(oauthWindowRef && oauthWindowRef.close) {
    oauthWindowRef.close();
  }

  oauthWindowRef = window.open(
    url,
    'oauth'
  );

  handlePost = postMessage.bind(null, dataPassed);
  window.addEventListener('message', handlePost);
  return teardown;
}

const teardown = () => {
  // remove postmessage listener
  if(handlePost) {
    window.addEventListener('message', handlePost);
  }

  // close window (if not already closed)
  if(oauthWindowRef && oauthWindowRef.close) {
    oauthWindowRef.close();
  }

  oauthWindowRef = null;
  handlePost = null;
}

const postMessage = (dataPassed, event) => {
  if(!event) {
    return;
  }

  let data = {};

  try {
    data = JSON.parse(event.data);
  } catch (err) {
    data = {};
  }

  if (data.action == 'onSuccess') {
    if(dataPassed.onSuccess) {
      dataPassed.onSuccess(data);
    }

    teardown()

  } else if (data.action == 'onError') {
    if(dataPassed.onError) {
      dataPassed.onError(data);
    }

    teardown()
  }
}

export const oauthFunction = (state, type) => {
  console.log('type', type)
  oauthInit(type, {
    onSuccess: payload => {
      console.log('payload', payload)

      if(!payload || !payload.auth_token) {
        return;
      }

      if (payload.auth_token) {
        localStorage.setItem('auth_token', payload.auth_token)
        state.getUserRequest();
      } else {
        const error = payload.error;
        state.setState({
          errorMessage: error
        });
        return error;
      }
    },
    onError: payload => {
      if(payload.error) {
        console.log('payload', payload)
      }

      const error = payload.error;
      state.setState({
        errorMessage: error
      });
      return error;
    }
  });
}
